import { ISVG } from "../UrlIcon";

export const HorizontalStartIcon = ({ className }: ISVG) => {
    return (
        <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" className={`${className}`}>
            <path d="M19.4 1.892H.6c-.33 0-.6.27-.6.6 0 .33.27.6.6.6h18.8c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6ZM13.814 6.877H.6c-.33 0-.601.27-.601.6 0 .33.27.6.6.6h13.214c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6ZM19.4 11.922H.6c-.33 0-.6.27-.6.6 0 .33.27.6.6.6h18.8c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6ZM9.07 16.907H.6c-.33 0-.6.27-.6.6 0 .33.27.6.6.6h8.47c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6Z" />
        </svg>
    );
};
